// Imports

import { PortalContext } from 'src/modules/01 Global/jsx/contexts.jsx';
import { ModalSection } from './modal-section.jsx';


// Stateful components

export class Modal extends React.Component{

    // Lifecycle

    constructor(props) {
        super(props);

        this.state = {
            'return_element': null
        };

        this.keypressHandler = this.keypressHandler.bind(this);
        this.backgroundClickHandler = this.backgroundClickHandler.bind(this);
        this.renderModalContent = this.renderModalContent.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.renderModalButtons = this.renderModalButtons.bind(this);
    }

    componentDidMount() {
        var this_component = this;

        // Get active element to return focus to
        this_component.setReturnElement();

        // Set keyboard focus
        this_component.setFocusOnModal();

        // Keypress handler
        document.addEventListener("keydown", this_component.keypressHandler, false);
        
        // Add body class
        document.querySelector('body').classList.add('modal--open');
    }

    componentWillUnmount(){
        var this_component = this;
        
        document.removeEventListener("keydown", this_component.keypressHandler, false);
        
        document.querySelector('body').classList.remove('modal--open');
    }


    // Functions

    keypressHandler(event) {
        var this_component = this;

        // ESC
        if(event.keyCode === 27) {
            this_component.closeModal(event);
        }
    }

    backgroundClickHandler(event) {
        var this_component = this;

        if(event.target.classList[0] === 'modal__wrapper') {
            event.preventDefault();
            this_component.closeModal(event);
        }
    }

    setReturnElement() {
        var this_component = this;
        var active_element = document.activeElement;

        this_component.setState({
            'return_element': active_element
        });
    }

    setFocusOnElement(target_element) {
        // Send user to destination element
        target_element["tabIndex"] = -1;
        target_element.focus();
        target_element["tabIndex"] = 0;
    }

    setFocusOnModal() {
        var this_component = this;
        var target_element = document.querySelector('.modal__content');
        
        this_component.setFocusOnElement(target_element);
    }

    closeModal(event) {
        var this_component = this;
        var return_element = this_component['state']['return_element'];
        var portal_context = this_component['context'];
        var modal_data = portal_context['modal_content'];
        
        if (modal_data['closeCallback']) {
            modal_data['closeCallback']();
        }

        // Return focus state
        this_component.setFocusOnElement(return_element);

        this_component['context']['helpers'].closeModal(event);
    }


    // Render

    renderModalContent() {
        var this_component = this;
        var portal_context = this_component['context'];
        var modal_data = portal_context['modal_content'];
        var close_modal = this_component.closeModal;

        return (
            <div className="modal__content">
                <div className="modal__header">
                    <span className="modal__title">{modal_data['title']}</span>
                    <a href="#" className="modal__close" onClick={close_modal}>Close</a>
                </div>
                <ModalSection modal_data={modal_data} buttons={this_component.renderModalButtons()}/>
            </div>
        );
    }

    renderModalButtons() {
        var this_component = this;
        var portal_context = this_component['context'];
        var modal_data = portal_context['modal_content'];
        var close_modal = this_component.closeModal;
        var modal_buttons = modal_data['buttons'];

        let buttons_markup = null;

        if (Array.isArray(modal_buttons)) {
            buttons_markup = modal_buttons.map((button, key) => {
                let action = button['action'] === 'custom' ? button['clickHandler'] : close_modal;
                return (
                    <button key={key} className={button['class']} onClick={action}>{button['label']}</button>
                );
            });
        }

        return buttons_markup;
    }

    render() {
        var this_component = this;
        var portal_context = this_component['context'];
        var modal_custom_class = portal_context['modal_content']['class'];
        var modal_content = this_component.renderModalContent();
        var modal_class = 'modal ' + modal_custom_class;

        return (
            <div className="modal__wrapper" onClick={this_component.backgroundClickHandler}>
                <div className={modal_class}>
                    <div className="modal__container">
                        {modal_content}
                    </div>
                </div>
            </div>
        );
    }
};

Modal.contextType = PortalContext;
